<template>
  <a-modal
    title="批属性"
    :visible="visible"
    :width="1040"
    class="bath-modal"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form-model :form="formData" v-bind="layout" layout="inline">
      <a-row>
        <a-col
          v-for="item in BATCHLIST"
          :key="item.value"
          :span="8"
        >
          <a-form-model-item :label="item.label">
            <component
              :is="item.type"
              v-model="formData[item.value]"
              allow-clear
              show-search
              :placeholder="item.placeholder"
              value-format="YYYY-MM-DD"
              :max-length="32"
              :options="item.options"
              v-bind="item.attributes"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import { BATCHLIST } from '../goodsTable';
import { getWarehouseDetail } from '../api';

export default {
  name: 'BatchProperties',
  data() {
    return {
      visible: false,
      chooseIndex: null,
      formData: {},
      chooseRow: {},
      BATCHLIST,
      layout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
      }
    }
  },
  methods: {
    async show(index, row) {
      const res = await getWarehouseDetail({
        id: row.skuId
      })
      const options = []
      res.supplierNames.forEach(item => {
        options.push({
          value: item,
          label: item
        })
      })
      this.BATCHLIST = BATCHLIST.map(item => {
        if (item.value === 'batchSupperName') {
          item.options = options
        }
        return item
      })
      this.visible = true;
      this.chooseRow = {...row};
      this.formData = {}
      try {
        if(row.batchAttrs) {
          row.batchAttrs.forEach(item => {
            this.$set(this.formData, item.attrCode, item.attrValue)
          })
        }
      }catch (e) {
        console.log(e)
      }
      this.chooseIndex = index
    },
    handleOk() {
      const batchAttrs = [];
      BATCHLIST.forEach(item => {
        if (this.formData[item.value]) {
          batchAttrs.push({
            attrCode: item.value,
            attrName: item.label,
            attrValue: this.formData[item.value]
          })
        }
      })
      this.$emit('changeBatchProperty', this.chooseIndex, {
        ...this.chooseRow,
        batchAttrs,
      });
      this.handleCancel()
    },
    handleCancel() {
      this.visible = false;
    }
  }
}
</script>

<style lang="less" scoped>
.bath-modal {
  .ant-form-item {
    width: 100%;
    .ant-calendar-picker {
      width: 100%;
    }
  }
}
</style>
